import React, { Component } from 'react';
import CommonSubHeader from '../../SubHeader';
import { inject, observer } from 'mobx-react';
import AirButton from '../../../../common/components/AirButton';
import PropTypes from "prop-types";

import './SubHeader.css';

@inject('translationsStore')
@observer
export default class SubHeader extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  componentDidMount = () => {
  };

  render() {
    const { translationsStore } = this.props;
    return (
      <CommonSubHeader className="GeoFenceSubHeader">
        <AirButton
          onClick={() => {
            this.context.router.history.push(`/geofence/0`);
          }
          } 
          size="large"
          label={translationsStore.translate('geofence.addNewGeofence')}
        />
      </CommonSubHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Geofence/SubHeader/SubHeader.js